import { Context } from '@nuxt/types'

export default function ({ $auth, $axios }: Context): void {
  $auth.$storage.watchState('loggedIn', (newValue: unknown) => {
    if (newValue === true) {
      $axios.post('/user/login')
    }
  })
}
